import { render } from "./form-number.vue?vue&type=template&id=36958cf0"
import script from "./form-number.vue?vue&type=script&lang=js"
export * from "./form-number.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__